import Vue from 'vue'
import customSelect from "./custom-select"
import customPermissions from './custom-permissions'

Vue.component('custom-select', customSelect)
Vue.component('custom-permissions', customPermissions)


// WEBPACK FOOTER //
// ./src/components/index.js